@if (epm.text$ | async; as text) {
  <div class="cookies">
    <ng-container>
      <div>
        <span>{{ 't.we-use-cookies' | translate }}. </span>
        @if (text === ' ') {
          <div>
            <span>{{ 't.see-our' | translate }} </span>
            <a class="pointer" (click)="goToPolicy()">{{ 'link.cookie-policy' | translate }} </a>
            <span>{{ 't.to-learn-more' | translate }}. </span>
          </div>
        }
        <span [innerHTML]="text"></span>
      </div>
      <button class="btn btn--filled-primary small accept" title="{{ 't.accept-cookies' | translate }}"
              (click)="cookiesAccepted()">
        {{ 't.accept' | translate }}
      </button>
    </ng-container>
  </div>
}
